import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFileAddPlus = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>FileAddPlus</title>
    <path
      d="M25.857 12.75v14.524a2.429 2.429 0 0 1-2.429 2.429H8.571a2.429 2.429 0 0 1-2.428-2.429V6.703A2.429 2.429 0 0 1 8.57 4.274h8.475c.622 0 1.22.239 1.67.666l6.383 6.046c.484.459.758 1.096.758 1.763Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path d="M16 24.418v-8M12 20.418h8" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path
      d="M25.713 12.417h-4.571a3.429 3.429 0 0 1-3.429-3.429V4.417"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoFileAddPlus;
